import ARCControlMapView from "components/navigation/map/ARCControlMapView";

/** Full live map + STCM map manager (fleet Map section). Used after exiting the BMP editor. */
const LiveStcmMapPage = () => {
    return (
        <div className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden">
            <div className="relative min-h-0 flex-1">
                <ARCControlMapView />
            </div>
        </div>
    );
};

export default LiveStcmMapPage;
